export default () => ({
    loading: true,
    accommodations: null,
    maleAccommodations: null,
    femaleAccommodations: null,
    currentAccommodation: null,
    totalItems: 0
})